/**
 * Build-Marker — AUTOMATISCH GENERIERT.
 * NICHT MANUELL EDITIEREN. Aenderungen werden ueberschrieben durch
 * scripts/generate-buildinfo.js (laeuft bei prestart/prebuild).
 *
 * Feature-Name aendern:  echo "mein-feature" > frontend/.build-feature
 * oder:                  BUILD_FEATURE_NAME=mein-feature yarn start
 */
export const BUILD_LABEL    = "05.10.2026 16:46 | nina-mobile-first-v1";
export const BUILD_VERSION  = "2026.10.05-nina-mobile-first-v1";
export const BUILD_DATE     = "05.10.2026 16:46";
export const BUILD_DATE_ISO = "2026-10-05T16:46:31.332Z";
export const BUILD_COMMIT   = "nina-mobile-first-v1";
export const BUILD_FEATURES = [];
